import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const CACHE_PREFIX = "kazerani:cache:";

const readCache = (key) => {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeCache = (key, data) => {
  try {
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ data, cached_at: new Date().toISOString() }));
  } catch {}
};

// Network-first with localStorage fallback so the board still shows the last known rates offline.
async function cached(key, fetcher, decorate) {
  try {
    const res = await fetcher();
    // Served by the service worker from its cache while offline — don't overwrite the fresh copy.
    if (res.headers?.["x-from-cache"]) throw Object.assign(new Error("offline"), { data: res.data });
    writeCache(key, res.data);
    return res.data;
  } catch (err) {
    const hit = readCache(key) || (err.data ? { data: err.data, cached_at: null } : null);
    if (!hit) throw err;
    return decorate ? decorate(hit.data, hit.cached_at) : hit.data;
  }
}

export const getBoard = () =>
  cached("board", () => api.get("/rates"), (data, cachedAt) => ({ ...data, offline: true, cached_at: cachedAt }));

export const getHistory = () => cached("history", () => api.get("/history").then((r) => ({ headers: r.headers, data: r.data.days || [] })));
